import React from 'react';
import { Modal, Box, Title, Group, Button, Text, Space } from '@mantine/core';
import { IoTrashOutline } from "react-icons/io5";
import { baseUrl } from '../../../../Constants/constant';
import useFetch from '../../../../Customhooks/useFetch';

const DeleterowData = ({
    isConfirmOpen,
    isSuccessOpen,
    closeConfirm,
    closeSuccess,
    selectedId,
    onDeleteSuccess
}: any) => {
    const token = localStorage.getItem("token");

    const { fetchData: deletedataapi } = useFetch({
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            token: token,
        },
        body : JSON.stringify({
            is_deleted:1
        })
    });

    const handleDelete = async () => {
        if (selectedId) {
            try {
                await deletedataapi(`${baseUrl}compute/lca/edit/${selectedId}`);
                closeConfirm();
                onDeleteSuccess();
            } catch (error) {
                console.error("Error deleting data:", error);
            }
        }
    };

    return (
        <>
            {/* Confirmation Modal */}
            <Modal opened={isConfirmOpen} onClose={closeConfirm} size="xs" centered withCloseButton={false}>
                <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                    <IoTrashOutline color="#df0000" size={100} />
                    <Box>
                        <Title order={2} ta="center">Are you sure you want <br /> to delete this report?</Title>
                        <Text ta="center" c="dimmed" size="md" mt="sm">
                            If you delete this report, it will no longer <br /> be registered on your platform!
                        </Text>
                    </Box>
                </Box>
                <Group mt="sm" justify="center">
                    <Button variant="default" w={120} radius={6} onClick={closeConfirm}>No</Button>
                    <Button
                        variant="gradient"
                        w={120}
                        gradient={{ from: '#404040', to: '#404040', deg: 90 }}
                        radius={6}
                        onClick={handleDelete}
                    >
                        Yes, I want
                    </Button>
                </Group>
            </Modal>

            {/* Success Modal */}
            <Modal opened={isSuccessOpen} onClose={closeSuccess} size="xs" centered withCloseButton={false}>
                <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                    <IoTrashOutline color="#008000" size={100} />
                    <Box>
                        <Title order={2} ta="center">Report Deleted!</Title>
                        <Text ta="center" c="dimmed" size="md" mt="sm">
                            Report has been deleted successfully. It’s <br /> no longer with your platform
                        </Text>
                    </Box>
                </Box>
                <Space h={'lg'}/>
                <Group mt="sm" justify="center">
                    <Button variant="filled" color="#404040" w={120} radius={6} onClick={closeSuccess}>OK</Button>
                </Group>
            </Modal>
        </>
    );
};

export default DeleterowData;